import React from 'react';

const ReusableTextField = ({
  id,
  name,
  label,
  required = false,
  type = 'text',
  placeholder = '',
  value,
  onChange,
  className = '',
  helpText = '',
  disabled = false,
}) => {
  return (
    <div className={`mb-3 ${className}`}>
      {label && (
        <label htmlFor={id || name} className="form-label fw-semibold">
          {label}{required && <span className="text-danger ms-1">*</span>}
        </label>
      )}
      <input
        id={id || name}
        name={name}
        type={type}
        className="form-control"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        required={required}
        disabled={disabled}
      />
      {helpText && (
        <div className="form-text">{helpText}</div>
      )}
    </div>
  );
};

export default ReusableTextField; 